module.exports = __webpack_public_path__ + "img/x8.377cb984.jpg";